/** A moment in the life of an annotation */

/** Fields of an annotation that are iElements of their own */

/**
 * @returns the iElement of the field when it holds a value.
 * Each field is its own iElement, so its dates tell when it was set, not the annotation's ones.
 */
export function getSetMarkupField(markup, field) {
  const isSet = field === "assignee" ? !!markup.assignee?.values?.length : !!markup[field]?.value;
  return isSet ? markup[field] : undefined;
}

/** @returns the annotation or the field of it that was modified last */
export function getMarkupLastUpdate(markup) {
  return [markup, markup.status, markup.assignee, markup.dueDate].filter(element => element !== undefined).reduce((latest, element) => Date.parse(element.modifiedAt) > Date.parse(latest.modifiedAt) ? element : latest);
}

/**
 * @returns when the annotation was created, its fields last set and it was last updated,
 * the oldest first
 */
export function getMarkupActivity(markup) {
  const entries = [{
    label: "Created",
    date: markup.createdAt,
    userId: markup.createdBy
  }];
  const fields = [["Status set", "status"], ["Assigned", "assignee"], ["Due date set", "dueDate"]];
  for (const [label, fieldName] of fields) {
    const field = getSetMarkupField(markup, fieldName);
    if (field) {
      entries.push({
        label,
        date: field.modifiedAt,
        userId: field.modifiedBy
      });
    }
  }
  const lastUpdated = getMarkupLastUpdate(markup);
  if (Date.parse(lastUpdated.modifiedAt) > Date.parse(markup.createdAt)) {
    entries.push({
      label: "Last updated",
      date: lastUpdated.modifiedAt,
      userId: lastUpdated.modifiedBy
    });
  }

  // Stable, so the creation stays first when a field was set at the same time
  return entries.sort((entry1, entry2) => Date.parse(entry1.date) - Date.parse(entry2.date));
}